import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import Button from 'components/Button';
import Message from 'components/Message';

const messages = defineMessages({
  stars: {
    id: 'ratings.ratings-summary.stars',
    defaultMessage: 'Stars',
  },
  ratings: {
    id: 'ratings.ratings-summary.ratings',
    defaultMessage: 'Ratings',
  },
  view: {
    id: 'ratings.ratings-summary.view',
    defaultMessage: 'View',
  },
});

const RatingsSummaryItem = ({ id, title, averageRating, ratingsCount, onViewClick }) => (
  <div key={id} className="ratings-summary__item" data-cypress="ratings-summary-item">
    <div className="ratings-summary__title grid__item 1/1 md-1/4">{title}</div>
    <div className="grid__item 1/3 md-1/4">
      <Message as="div" format="one-decimal" value={averageRating} />
      <div className="ratings-summary__subtitle">
        <Message message={messages.stars} />
      </div>
    </div>
    <div className="grid__item 1/3 md-1/4">
      <Message as="div" value={ratingsCount} />
      <div className="ratings-summary__subtitle">
        <Message message={messages.ratings} />
      </div>
    </div>
    <div className="grid__item 1/3 md-1/4 ratings-summary__button-container">
      <Button className="bt--width-full" onClick={() => onViewClick(id)}>
        <Message message={messages.view} />
      </Button>
    </div>
  </div>
);

RatingsSummaryItem.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  averageRating: PropTypes.number,
  ratingsCount: PropTypes.number,
  onViewClick: PropTypes.func,
};

export default RatingsSummaryItem;
